import styled, { css } from 'styled-components';
import { Button, CodeTag } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledH3 = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.text.main};
  margin: 4.6rem 0 0.9rem 0;
`;

export const StyledH3SubTitle = styled(StyledH3)`
  margin-top: 3.2rem;
`;

export const StyledPDescription = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.text.main};
  margin: 0;
`;

export const StyledCodeTag = styled(CodeTag)`
  margin-top: 1.6rem;
  white-space: nowrap;
  overflow-x: auto;
  max-width: 67rem;
  display: block;
`;

export const StyledIframe = styled.iframe`
  margin-top: 1.6rem;
  width: 100%;
  border: none;
  height: 9rem;
`;

export const StyledIconButton = styled(Button)`
  background: ${({ theme }) => theme.colors.button.close.background};

  svg {
    font-weight: 900;
    height: 1.9rem;
    width: 1.6rem;
  }
`;

export const StyledRotateIcon = styled(FontAwesomeIcon)`
  font-weight: 900;
  font-size: 1.6rem;
`;

export const StyledBadgeImageWrapper = styled.div`
  margin-top: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  align-items: flex-start;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const StyledImageWrapper = styled.div`
  max-width: 32.8rem;
  max-height: 8.7rem;
`;

export const StyledModalFooter = styled.footer`
  border-top: 0.1rem solid ${({ theme }) => theme.colors.border.dropdown};
  padding-top: 1.8rem;
  margin-top: 2.4rem;

  button {
    // Display block is used here to show ellipsis when text is too long
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: auto;
  }
`;

export const StyledFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }
`;

export const StyledIconsLegend = styled.div`
  background: ${({ theme }) => theme.colors.background.tableOdd};
  padding: 0.8rem 1.6rem;
  border-radius: ${({ theme }) => theme.radius.small};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 1.6rem;
  row-gap: 0;
`;

export const StyledLegendText = styled.p<{ $isBolder?: boolean }>`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme, $isBolder }) => ($isBolder ? theme.fonts.weight.bolder : theme.fonts.weight.regular)};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  line-height: ${({ theme, $isBolder }) => ($isBolder ? '1.8rem' : theme.fonts.lineHeight.default)};
  color: ${({ theme }) => theme.colors.text.main};
  margin: 0;
  display: inline-block;
  white-space: nowrap;
`;

export const StyledLegendIconsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledLegendIcon = styled(FontAwesomeIcon)<{ $legendType: string }>`
  text-align: center;
  font-weight: 900;
  ${({ theme, $legendType }) => {
    switch ($legendType) {
      case 'level': {
        return css`
          color: ${theme.colors.activityCalendar.levelOne};
          font-size: 1.6rem;
          margin-right: 0.4rem;
        `;
      }
      case 'rank': {
        return css`
          color: ${theme.colors.grey[500]};
          font-size: 1.4rem;
          margin-right: 0.5rem;
        `;
      }
      case 'badges': {
        return css`
          color: ${theme.colors.purple.light};
          font-size: 1.6rem;
          margin-right: 0.4rem;
        `;
      }
      case 'streak': {
        return css`
          color: ${theme.colors.primary.main};
          font-size: 1.6rem;
          margin-right: 0.4rem;
        `;
      }
      case 'completed rooms': {
        return css`
          color: rgba(113, 156, 249, 1);
          font-size: 1.5rem;
          margin-right: 0.45rem;
        `;
      }
      default: {
        return css``;
      }
    }
  }}
`;
